import CustomerId    from "../../../domain/customer/CustomerId";
import { ApiClient } from "../../configure/ApiClientConfig";

export const apiGetCustomerHasAccount = async (customerId: CustomerId): Promise<boolean> => {
  try {
    const response = await ApiClient.get("/customer/has/account", {
      params: {
        customer_id: customerId.value,
      }
    });
    return response.data;
  } catch (e) {
    return false;
  }
}